import $ from "jquery";
import { checkRequiredFields } from "./forms";

const cabinet = () => {
    const historyPage = $(".history");
    const profilePage = $(".profile");
    const promocodePage = $(".promocode");

    if (historyPage.length) {
        const itemToggle = $(".history__item .toggle");

        itemToggle.click(function () {
            $(this)
                .toggleClass("active")
                .closest(".history__item")
                .toggleClass("open")
                .find(".more")
                .slideToggle();
        });
    }

    if (profilePage.length) {
        //включение/отключение редактирования
        $(".edit").click(function () {
            $(this).parent().find("input, select").prop("disabled", false);
        });

        //Показ превьюшки логотипа
        $(".logo__file").change(function () {
            if (this.files[0]) {
                const fr = new FileReader();

                fr.onload = function () {
                    $(".logo__text")
                        .addClass("active")
                        .css({
                            "background-image": `url(${fr.result})`,
                        });
                };

                fr.readAsDataURL(this.files[0]);
            }
        });
    }

    if (promocodePage.length) {
        // скрипт копирования в буфер обмена через создание textarea
        $(".js-promocode-copy").click(function () {
            const copyText = $(this).text();
            const $temp = $("<textarea>");
            $("body").append($temp);
            $temp.val(copyText).select();
            document.execCommand("copy");
            $temp.remove();
            $(this).addClass("copied");
            setTimeout(() => {
                $(this).removeClass("copied");
            }, 5000);
        });
        $("input[form=subscribe]").change(function () {
            const value = $(this).val();

            $(".form#subscribe .form__item .form__label").text(
                `Ссылка на аккаунт ${value}*`,
            );
        });

        const $form = $(".js-referral-subscribe");
        const $agreeCheck = $form.find(".js-agree");

        $agreeCheck.on("change", function () {
            if ($(this).is(":checked")) {
                $(this).removeClass("error");
            }
        });

        const submitSubscribe = () => {
            const $message = $form
                .find(".js-subscribe-message")
                .prop("hidden", true)
                .removeClass("error");
            $agreeCheck.removeClass("error");

            if (!checkRequiredFields($form)) {
                return;
            }

            const formData = $form.serializeArray();
            const urlType = $('input[name="url_type"]:checked').val();

            if (urlType) {
                formData.push({ name: "url_type", value: urlType });
            }

            $.ajax({
                url: $form.attr("action"),
                method: "POST",
                data: $.param(formData),
                headers: {
                    "X-Requested-With": "XMLHttpRequest",
                    "X-CSRF-Token": window.csrfToken,
                },
                success(response) {
                    const data =
                        typeof response === "string"
                            ? JSON.parse(response)
                            : response;

                    if (data.success) {
                        $(".js-subscribe-form-wrap").remove();
                        $(".js-subscribe-item .item__tabs").remove();
                        $(".js-subscribe-item").append(`
                            <div class="item__content">
                                <div class="wysiwyg">
                                    <p>${data.message || "Информация об изменениях придёт на указанный адрес"}</p>
                                </div>
                            </div>
                        `);
                        return;
                    }

                    $message
                        .text(data.message || "")
                        .prop("hidden", false)
                        .addClass("error");

                    if (!$agreeCheck.is(":checked")) {
                        $agreeCheck.addClass("error");
                    }
                },
                error() {
                    $message
                        .text("Не удалось отправить форму")
                        .prop("hidden", false)
                        .addClass("error");
                },
            });
        };

        $form.on("submit", (event) => {
            event.preventDefault();
            submitSubscribe();
        });

        $(".js-subscribe-submit").on("click", (event) => {
            event.preventDefault();
            submitSubscribe();
        });

        $(".js-certificate-partner-form").on("submit", function (event) {
            const $form = $(this);
            const $input = $form.find(".js-certificate-points");
            const points = parseInt($input.val(), 10);
            const min = parseInt($input.attr("min"), 10);
            const max = parseInt($input.attr("max"), 10);

            if (Number.isNaN(points) || points < min || points > max) {
                event.preventDefault();
                alert(`Укажите количество баллов от ${min} до ${max}`);
                return;
            }

            if (!window.confirm(`Списать ${points} баллов на сертификат?`)) {
                event.preventDefault();
            }
        });
    }
};

export default cabinet;
